<script setup>

import {computed, provide} from "vue";

const inputValue = defineModel();
const emit = defineEmits(['select']);

const props = defineProps({
    size: {
        type: String,
    },
    height: {
        type: [Number, String],
    },
});

provide('selectionButtonValue', inputValue);
provide('selectionButtonValueUpdate', (newValue) => {
    inputValue.value = newValue;
    emit('select', newValue);
});

const buttonProps = computed(() => {
    const result = {};
    if (props.size) {
        result.size = props.size;
    }
    if (props.height) {
        result.height = props.height;
    }
    return result;
});
provide('selectionButtonProps', buttonProps);
</script>

<template>
    <v-input>
        <div class="flex-grow-1 d-flex ga-2 flex-wrap">
            <slot></slot>
        </div>
    </v-input>
</template>
